import { useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import AuthLayout from "../../components/AuthLayout"
import Input from "../../core-ui/Input"
import { EyeIcon, EyeOffIcon } from "lucide-react"
import { Link } from "react-router-dom"
import { useForm } from "react-hook-form"
import API from "../../utils/apiClient"
import { useUser } from "../../utils/UserProvider"
import { useToast } from "../../utils/ToastProvider"

const SignUp = () => {
  const navigate = useNavigate()
  const { addToast } = useToast()

  const { user } = useUser()

  if (user) {
    navigate("/app")
  }
  const [showPassword, setShowPassword] = useState(false)
  const [searchParams] = useSearchParams();

  const ref = searchParams.get("ref");
  const email = searchParams.get("email")

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      password: "",
      name: "",
      mobile: "",
    }
  })

  const onSubmitHandler = async (data) => {
    try {
      const res = await API.post("/user/signup", {
        name: data.name,
        verificationRef: ref,
        email: email,
        password: data.password,
        mobile: data.mobile
      })
      if (res.data.status === "success") {
        addToast({
          title: "Success!",
          description: "Account is successfully created."
        })
        navigate("/app")
      }
    } catch (completeSignupError) {
      addToast({
        title: "Error!",
        description: "Unexpected error occured. Try Again.",
        type: "error"
      })
    }
  }

  return (
    <AuthLayout>
      {/* Heading */}
      <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
        Complete the Registeration !
      </h1>
      <p className="text-center text-gray-500 mb-8">
        Enter your name, number and password to signup
      </p>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmitHandler)} className="space-y-6">
        {/* Email Input */}
        <div className="relative">
          <Input
            type="text"
            name="name"
            placeholder="Full Name"
            required={true}
            register={register}
          />
          {errors.name && <p className="mt-2 text-secondary">Name is required</p>}
        </div>

        {/* Phone Number Input */}
        <div className="relative">
          <Input
            type="text"
            name="mobile"
            placeholder="Phone Number"
            required={true}
            register={register}
          />
          {errors.mobile && <p className="mt-2 text-secondary">Phone Number is required</p>}
        </div>
        {/* Password Input */}
        <div className="relative">
          <Input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            required={true}
            register={register}
          />
          {errors.password && <p className="mt-2 text-secondary">Password is required</p>}
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2"
          >
            {showPassword ? (
              <EyeOffIcon className="w-5 h-5 text-gray-400" />
            ) : (
              <EyeIcon className="w-5 h-5 text-gray-400" />
            )}
          </button>
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primaryDark transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium"
        >
          Sign Up
        </button>
      </form>

      {/* Sign Up Link */}
      <p className="mt-8 text-center text-gray-500 text-sm">
        Already have an Account ? {" "}
        <Link to="/login" className="text-primary hover:text-primaryDark font-medium">
          Login
        </Link>
      </p>
    </AuthLayout >
  )
}

export default SignUp
